define('page/render', [],function () {
    var elm = document.querySelector('div[data-module]');
    if (elm) {
        var moduleId = elm.getAttribute('data-module');
        moduleId && require([moduleId]);
    }
})  ;
